export * from './get-static-paths'
export * from './adapters'
export { StoryblokRenderer } from './renderer'
export {
  StoryblokRenderer as StoryblokRendererV2,
  type ComponentLayouts,
} from './renderer-v2'
